import { CompanyUpdatePayload } from "../Company/types"
import { TradingCompanyDetail } from "../types"

/**
 * This function cleans the updated company before sending it to back-end
 */
export const formatCompany = (company: TradingCompanyDetail): CompanyUpdatePayload => {
  const formattedData = {
    name: company.name,
    headquarter_country_id: company.headquarter_country ? company.headquarter_country.id : null,
    reporting_currency_id: company.reporting_currency ? company.reporting_currency.id : null,
    cyclicality: company.cyclicality,
    sectors: [
      {
        id: company.sectors[0].id,
        level: company.sectors[0].level,
      },
      {
        id: company.sectors[1].id,
        level: company.sectors[1].level,
      },
      {
        id: company.sectors[2].id,
        level: company.sectors[2].level,
      },
    ],
  }

  return formattedData
}
